import SessionLayout from '@/layouts/SessionLayout/SessionLayout';

export default SessionLayout;
